module.exports = __webpack_public_path__ + "img/52_48.9f3a3f73.png";